import cn from 'classnames';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import readXlsxFile from 'read-excel-file';
import { uiChangeProvider } from '../../../../../actions/ui';
import { TYPE_BUTTONS } from '../../../../../constans';
import { Column, Row, WhiteBlock } from '../../../Blocks';
import { Select } from '../../../Inputs';
import Button from '../../Button';
import ExportExcelFileButton from '../ExcelExportFile';
import styles from './styles.module.scss';
import { Text } from '../../../WrapsStyle';

const ImportExcelNomenclatureStocksButton = ({
  width = 'default',
  height = '36px',
  style,
  onChange = (_) => _,
  redButton = false,
  children,
  sliceLine = 1,
  ...props
}) => {
  const allProviders = useSelector((store) => store.providers);
  const selectProvider = useSelector((store) => store.ui.selectProvider);
  const [providers, setProviders] = useState([]);
  const [provider, changeProvider] = useState({});
  const dispatch = useDispatch();

  let [excel, setExcel] = useState([]);
  const parseData = async (files) => {
    let array = [];

    const readFileOne = async (file, i) => {
      return await readXlsxFile(file).then((rows) => {
        let keys = {};

        rows[16].forEach((item, key) => {
          // 13 c поступлений
          keys[key] = item;
        }); // забираем наименование столбцов с шапки

        const data = rows
          .slice(17) // 13 c поступлений
          .map((d) => {
            const row = {};
            d.forEach((item, key) => {
              row[keys[key]] = item;
            });
            return row;
          })
          /*           .filter( // c поступлений
            (item) => 
              item['1а'] != '#ERROR_undefined' &&
              item['1а'] != 'null' &&
              item['1а'] !== null &&
              item['1а'] !==
                'Наименование товара (описание выполненных работ, оказанных услуг), имущественного права' &&
              item['1а'] !== '1а',
          ); */
          .filter((item) => item['1а'] != '#ERROR_undefined' && item['1а'] != 'null' && item['1а'] !== null);

        /*   const true_data = data.map((item) => ({
          Артикул: `${item['А'].slice(item['А'].indexOf('-') + 1)}`,
          Наименование: item['1а'],
          Наличие: item['3'],
          Цена: item['9'] / item['3'],
        })); */

        const true_data = data.map((item) => ({
          Артикул: `${item['А']}`,
          Наименование: item['1а'],
          Количетсво: item['3'],
          Цена: item['9'] / item['3'],
        }));

        array.push(...true_data);
        return true_data;
      });
    };

    let files_array = Array.from(files);
    console.log('files', files, Array.from(files));
    for (let i = 0; i < files_array.length; i++) {
      let res = await readFileOne(files_array[i], i);
      array.push(res);
    }

    let new_excel = _.uniqBy([...excel, ...array], 'Артикул').filter((item) => item['Артикул']?.length > 2);
    setExcel(new_excel);
  };

  const onLoad = async (e) => {
    let files = e.target.files;

    console.log(files);
    parseData(files);
    e.target.value = null;
  };

  const calcDownloadedData = useCallback(() => {
    return excel;
  }, [excel]);

  console.log(provider);

  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  useEffect(() => {
    if (selectProvider) {
      changeProvider(selectProvider);

      const provider_data = providers.find((item) => selectProvider.id === item.id);
      if (provider_data) {
        changeProvider(provider_data); // прогрузка времени обновления остатка
      }
    } else {
      const p = allProviders.filter((item) => item.is_stock);
      changeProvider(p[0] || {});
    }
  }, [selectProvider, providers]);

  return (
    <Column>
      <WhiteBlock title={'Наличие'}>
        <Select
          width={'200px'}
          label="Поставщик"
          select={provider}
          valueFn={(p) => p?.name}
          list={providers}
          onSelect={(v) => dispatch(uiChangeProvider(v))}
        />

        <Row style={{ marginTop: '15px' }}>
          <label style={{ width, height, ...style }}>
            <span className={cn(styles.button_base, styles.button_green, redButton && styles.button_red, props.styles)}>
              Загрузить файлы
            </span>
            <input type="file" className={styles.input} onChange={(e) => onLoad(e)} multiple />
          </label>

          <ExportExcelFileButton
            style={{ marginLeft: '15px' }}
            filename={`Номенклатруа ${provider?.name} ${excel.length}`}
            data={{
              'Заказ общий': calcDownloadedData(),
            }}
            buttonTitle={`Скачать номенклатуру`}
          />
          <Button type={TYPE_BUTTONS.RED} style={{ marginLeft: '15px' }} onClick={() => setExcel([])}>
            Очистить
          </Button>
        </Row>

        <Text style={{ marginTop: '15px' }}>{`Обработанно: ${excel.length}`}</Text>
      </WhiteBlock>
    </Column>
  );
};

export default ImportExcelNomenclatureStocksButton;
